/*jshint esversion: 6 */
// MyProfile Components -------------------------------------- *
import '../Views/Feature/MyProfile/BusinessQuestionsBlockAndForm/businessQuestionsBlockAndForm';
import '../Views/Feature/MyProfile/ContactInfoBlockAndForm/contactInfoBlockAndForm';
import '../Views/Feature/MyProfile/RegistrationForm/registrationForm';